import Banner from "../../sections/common/banner";
import { useLangagesStore } from "../../../context/langages";
import { data as dataES } from "../../../globals/data/es/ofac";
import { data as dataEN } from "../../../globals/data/en/ofac";
import { data as dataCN } from "../../../globals/data/zh/ofac";
import SectionOfac from "../../sections/ofac/section-ofac";


export default function OfacLicensesPage() {
  const language = useLangagesStore((state) => state.langage);
  const data = language === "en" ? dataEN : language === "cn" ? dataCN : dataES;
  const sectionData = data.features || dataES.features;

  return (
    <>
      <Banner _data={data.banner} />
      <SectionOfac _data={sectionData} />
    </>
  );
}
